import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { TagRatingSize, TagRatingType } from '@design-system/components/molecules/tag-rating/entities/tag-rating.types';
import { DividerOrientation } from '@design-system/components/atoms/divider/entities/divider.types';
import { getLegendByScore } from '@shared/score-detail/helpers/label-score.helper';

@Component({
  selector: 'app-score-detail',
  templateUrl: './score-detail.component.html',
  styleUrls: ['./score-detail.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ScoreDetailComponent {

  @Input() score: number;
  @Input() withBorder: boolean;

  public readonly tagRatingSize = TagRatingSize.SM;
  public readonly tagRatingType = TagRatingType.Rating;

  public readonly dividerOrientation = DividerOrientation.Vertical;

  constructor() { }

  get hasScore(): boolean {
    return !!this.score;
  }

  get legendByScore(): string {
    return getLegendByScore(this.score);
  }
}
